import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

const en = {
    hello: 'Hello'
};

const de = {
    hello: 'Hallo'
};

i18next
    .use(initReactI18next)
    .use({
        type: 'postProcessor',
        name: 'lazyInterpolateWithFunctions',
        process: function (value, key, options) {
            return options.skipInterpolation ? replaceKeys(value, options) : value;
        }
    })
    .init({
        resources: {
            en: { translation: en },
            de: { translation: de }
        },
        lng: 'de',
        fallbackLng: 'en',
        postProcess: ['lazyInterpolateWithFunctions'],
        interpolation: {
            escapeValue: false,
            prefix: '{',
            suffix: '}'
        }
    });

export const i18n = i18next;
const ns = 'translation';

export const addTranslation = (lang, data) => {
    i18n.addResourceBundle(lang, ns, { ...data });
};

export const updateTranslation = (lang, data) => {
    i18n.removeResourceBundle(lang, ns);
    addTranslation(lang, data);
};
